module.exports = __webpack_public_path__ + "img/ankara-sigorta.192530ea.jpg";